const LOGO_URL = "https://customer-assets.emergentagent.com/job_masar-mobile-app/artifacts/ike4zylk_MASAR%20app.png";

export default function BrandMark({ className = "", size = 36 }) {
  return (
    <img
      src={LOGO_URL}
      alt="MASAR"
      width={size}
      height={size}
      className={`inline-block rounded-lg object-contain ${className}`}
      loading="eager"
      decoding="async"
    />
  );
}
